import { useTranslation } from 'react-i18next';
import {
  PasswordResetLayout,
  ResetPasswordContent,
  ResetPasswordPromoPane,
  StepIndicator,
} from '@features/PasswordReset';

export default function ResetPasswordPage() {
  const { t } = useTranslation();
  return (
    <PasswordResetLayout
      promo={<ResetPasswordPromoPane />}
      stepIndicator={
        <StepIndicator
          steps={[
            { label: t('auth.reset.stepTags.a'), state: 'done' },
            { label: t('auth.reset.stepTags.b'), state: 'done' },
            { label: t('auth.reset.stepTags.c'), state: 'active' },
          ]}
        />
      }
    >
      <ResetPasswordContent />
    </PasswordResetLayout>
  );
}
